'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventPropertySchema = exports.eventDefinitionSchema = undefined;

var _taxonomy = require('./taxonomy');

var _messages = require('../common/messages');

var _schema = require('../common/schema');

var schema = _interopRequireWildcard(_schema);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var eventDefinitionSchema = exports.eventDefinitionSchema = schema.create('event property', _messages.configError, {
  name: {
    types: ['string']
  },
  class: {
    types: ['string'],
    oneOf: _taxonomy.eventClasses
  },
  version: {
    types: ['string'],
    default: 'v1'
  },
  properties: {
    types: ['object'],
    default: {}
  }
});

var eventPropertySchema = exports.eventPropertySchema = schema.create('event property', _messages.configError, {
  type: {
    types: ['string', 'array'],
    oneOf: _taxonomy.eventPropertyTypes
  },
  isOptional: {
    types: ['boolean'],
    default: false
  }
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.74/js/dictionary/schemas.js
// module id = 395
// module chunks = 0